import axios from 'axios'


export function ScollPostion() {
    var t, l, w, h;
    if (document.documentElement && document.documentElement.scrollTop) {
        t = document.documentElement.scrollTop;
        l = document.documentElement.scrollLeft;
        w = document.documentElement.scrollWidth;
        h = document.documentElement.scrollHeight;
    } else if (document.body) {
        t = document.body.scrollTop;
        l = document.body.scrollLeft;
        w = document.body.scrollWidth;
        h = document.body.scrollHeight;
    }
    return {
        top: t,
        left: l,
        width: w,
        height: h
    };
}

export function getElementPosition(e) {
    var x = 0, y = 0;
    while(e != null) {
        x += e.offsetLeft;
        y += e.offsetTop;
        e = e.offsetParent;
    }
    return { x: x, y: y };

}

export function getLoginURL(pathname){
   /*
    axios.get('/fapi/getLoginURL?redirect_url='+pathname)
      .then(res=>{
        
        if(res.data.return_code==0){
            window.location.href = res.data.redirect_url
 
        }
    })
    */
 
     const ipath = {
        pathname:'/login',
        query:this.props.location.pathname
    }

    this.props.history.push(ipath)
   //this.props.history.push('/login')
    
}
export function setCookie(key, value) {
    const d = new Date();
    d.setTime(d.getTime() + ( 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toGMTString();
    document.cookie = key + "=" + value + "; " + expires;
   
}
 
 


// WEBPACK FOOTER //
// ./src/util.js